module.exports = __webpack_public_path__ + "img/iconCC-Social3.532f1285.png";